module.exports = __webpack_public_path__ + "img/banner.f1461510.svg";